import { createSlice } from '@reduxjs/toolkit';
import { ACTIVE_IMPERSONATOR } from '../../constants/session-storage-keys';
import { setInSessionStorage, removeFromSessionStorage } from '../../utils/session-storage-utils';

const initialState = {
  userList: [],
  active: false,
  activeUser: null,
};

const impersonateUserSlice = createSlice({
  name: 'impersonateUser',
  initialState,
  reducers: {
    update: (state, { payload }) => ({ ...state, ...payload }),
    updateUser: (state, { payload }) => {
      state.active = !!payload;
      state.activeUser = payload;
      setInSessionStorage(ACTIVE_IMPERSONATOR, payload);
    },
    updateUserList: (state, { payload }) => ({
      ...state,
      userList: payload,
    }),
    resetUser: (state) => {
      state.active = false;
      state.activeUser = null;
      removeFromSessionStorage(ACTIVE_IMPERSONATOR);
    },
    reset: () => initialState,
  },
});

export const {
  update: updateImpersonateReducer,
  reset: resetImpersonatorReducer,
  resetUser: resetImpersonator,
  updateUser: updateImpersonator,
  updateUserList: updateImpersonatorList,
} = impersonateUserSlice.actions;

export default impersonateUserSlice.reducer;
